import {
  REPORT_FOOTER_PLUM,
  REPORT_STATUS_GREEN,
} from "./print-controls-helpers";

export const PrintStyles = () => (
  <style>
    {`
      script#pylon-widget,
      iframe[src*="widget.usepylon.com/widget/"],
      iframe[src*="usepylon.com/widget/"],
      [id^="pylon-"],
      [class^="pylon-"],
      [class*=" pylon-"] {
        display: none !important;
        visibility: hidden !important;
      }

      .print-footer {
        display: none;
      }

      .controls-report-print-source {
        position: fixed;
        top: 0;
        left: -10000px;
        width: 8.5in;
        height: 0;
        overflow: hidden;
        pointer-events: none;
        visibility: hidden;
      }

      .auto-print-mode .print-container {
        visibility: hidden;
        position: absolute;
        left: -9999px;
      }
      @media print {
        body.controls-report-printing #app {
          display: none !important;
        }
        body.controls-report-printing .controls-report-print-source {
          position: static !important;
          width: 100% !important;
          height: auto !important;
          overflow: visible !important;
          pointer-events: auto !important;
          visibility: visible !important;
        }
        body.controls-report-printing .controls-report-print-source * {
          visibility: visible !important;
        }
        .auto-print-mode .print-container {
          visibility: visible !important;
          position: static !important;
          left: auto !important;
        }
        .auto-print-message {
          display: none !important;
        }
      }

      @media print {
        /* Zero page margins suppress browser print headers/footers (URL, page #, title). */
        @page {
          size: letter;
          margin: 0;
        }

        .print-report-root,
        .print-container {
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }

        html,
        body,
        .print-report-root {
          height: auto !important;
          min-height: auto !important;
          overflow: visible !important;
        }

        .print-container {
          width: 100% !important;
          max-width: none !important;
          min-height: auto !important;
          overflow: visible !important;
          /* Bottom padding reserves space for the fixed print footer on every page. */
          padding: 0.5in 0.5in 1.15in 0.5in !important;
        }

        .cover-page {
          min-height: 10in;
          padding-top: 0.25in !important;
          margin-top: 0 !important;
        }
        .cover-generated-box {
          page-break-inside: avoid;
          break-inside: avoid;
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
        .intro-page,
        .infra-compliance-page,
        .controls-section {
          padding-top: 0.5in !important;
          margin-top: 0 !important;
        }

        nav, button, .no-print {
          display: none !important;
        }

        .intro-page {
          page-break-after: always;
          break-after: page;
        }
        .infra-compliance-page {
          page-break-before: always;
          break-before: page;
        }
        .compliance-overview-section {
          page-break-inside: avoid;
          break-inside: avoid;
          max-width: 100%;
          overflow: visible;
        }
        .compliance-overview-section .compliance-cards-grid {
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
          gap: 0.5rem;
        }
        .controls-section {
          page-break-before: always;
          break-before: page;
          margin-top: 0;
        }
        /*
         * Keep each control box intact across page breaks. Some print engines
         * ignore break-inside on flex/grid descendants, so we apply the rule
         * to the item, both inner sections, and any direct child wrappers.
         * orphans/widows give the engine room to push the whole block to the
         * next page when it won't fit on the current one.
         */
        /*
         * One gap between controls: padding-top on siblings only (not top+bottom
         * on every wrap, which doubled spacing mid-page). Padding survives page
         * breaks when a box is pushed to the next sheet; margin-top would collapse.
         */
        .controls-section > .border-b {
          margin-bottom: 0.4in !important;
        }
        .control-item-wrap {
          display: block;
          margin-bottom: 0 !important;
          page-break-inside: avoid !important;
          break-inside: avoid-page !important;
          -webkit-column-break-inside: avoid !important;
          orphans: 4;
          widows: 4;
        }
        .control-item-wrap + .control-item-wrap {
          padding-top: 0.4in;
        }
        .control-item-wrap .control-item {
          margin: 0 !important;
          padding: 0.2in 0.25in !important;
        }
        .control-item *,
        .control-item-header,
        .control-item-body {
          page-break-inside: avoid !important;
          break-inside: avoid-page !important;
        }

        * {
          box-shadow: none !important;
        }

        * {
          color: black !important;
        }
        .text-forest { color: ${REPORT_STATUS_GREEN} !important; }
        .text-red { color: #AD1A1A !important; }
        .text-amber-700 { color: #b45309 !important; }
        .text-gray-600 { color: #4b5563 !important; }
        .text-indigo { color: #4f46e5 !important; }

        .report-status-badge {
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }

        div {
          background-color: white !important;
        }

        .print-footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 0.08in 0.5in;
          z-index: 1;
          display: flex !important;
          justify-content: space-between;
          align-items: center;
          margin: 0 !important;
          font-size: 8pt;
          color: black !important;
          box-sizing: border-box;
        }
        .print-footer a {
          color: ${REPORT_FOOTER_PLUM} !important;
          text-decoration: underline;
          min-width: 0;
        }
        .text-plum {
          color: ${REPORT_FOOTER_PLUM} !important;
        }
      }
    `}
  </style>
);
